import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const CSPPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default CSPPVMonitorPage;
